import {userCanRepurpose} from '@netx/core-asset-repurpose';
import {currentCartIsNotEmpty} from './currentCartIsNotEmpty';

export const canRepurposeCurrentCart = () =>
	currentCartIsNotEmpty() && userCanRepurpose();

export default canRepurposeCurrentCart;
